<template>
  <FormSection title="Account">
    <template #text>
      Lösche Deinen Accout bei St. Audio
    </template>
    <template #form>
      <DeletionForm :resource="resource" :errors="errors" />
    </template>
  </FormSection>
  <FormButtons>
    <SubmitButton @click="onSubmit" :load="removing">
      Account Löschen
    </SubmitButton>
  </FormButtons>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRemoveResource } from '@/client/actions';

const store = useStore();
const router = useRouter();

const target = computed(() => '/api/account');
const action = useRemoveResource(target);

const { resource, errors, message, remove, removing } = action;

const onSuccess = () => {
  console.log("Logout successful");
  router.push({ name: "login" });
};

const onFailure = () => {
  console.log("Logout failed");
  router.push({ name: "login" });
};

const onLogout = () => {
  store.dispatch('auth/logout')
  .then(result => onSuccess(result))
  .catch(error => onFailure(error));
};

const onSubmit = () => remove(onLogout);
</script>
